import {INote, Note} from 'app/blocks/model/note.model';
import {IContactInfo, ContactInfo} from 'app/blocks/model/contact-info.model';
import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';
import {IAddress} from 'app/blocks/model/address.model';
import {ITrafficArea, TrafficArea} from 'app/blocks/model/traffic-area.model';
import {ITpVehicleSkill} from 'app/blocks/model/tp-vehicle-skill.model';
import {DiTime} from 'app/blocks/util/di-time';

export interface ILocationPoint extends IBaseEntity {
    id?: number;
    name?: string;
    description?: string;
    underReview?: boolean;
    residential?: boolean;
    contactInfo?: IContactInfo;
    ciAddress?: IAddress;
    notes?: INote;
    organisationId?: number;
    organisationName?: string;
    trafficArea?: ITrafficArea;
    tp_required_location_skills?: ITpVehicleSkill[];
    timeToService?: number;
    podRequired?: boolean;
    isEmailNotificationEnabled?: boolean;
    emailForDeliveryNotification?: string;
    notifyForDeliveryNotification?: string;
    deleted?: boolean;
    awaitingApproval?: boolean;
    type?: LocationPointType;
    hasStandingTrailers?: boolean;
    startTime?: any;
    endTime?: any;
    hasFixedPrice?: boolean;
    fixedPrice?: number;
    surveyId?: number;
    warehouse?: boolean;
    creationDate?: string;
    trafficAreaDesc?: string;
}

export enum LocationPointType {
    DEPOT = 'DEPOT',
    OFFICE = 'OFFICE',
    HEAD_OFFICE = 'HEAD_OFFICE'
}

export class LocationPoint extends BaseEntity implements ILocationPoint {
    postCodeZip?: string;
    public id?: number;
    public name?: string;
    public description?: string;
    public underReview?: boolean;
    public residential?: boolean;
    public contactInfo?: IContactInfo;
    public ciAddress?: IAddress;
    public notes?: INote;
    public organisationId?: number;
    public organisationName?: string;
    public trafficArea?: ITrafficArea;
    public tp_required_location_skills?: ITpVehicleSkill[];
    public timeToService?: number = 0;
    public podRequired?: boolean;
    public isEmailNotificationEnabled?: boolean;
    public emailForDeliveryNotification?: string;
    public notifyForDeliveryNotification?: string;
    public deleted?: boolean;
    public awaitingApproval?: boolean;
    public type?: LocationPointType;
    public completeAddress?: string;
    public hasStandingTrailers?: boolean;
    public startTime?: any;
    public endTime?: any;
    public hasFixedPrice?: boolean;
    public fixedPrice?: number;
    public surveyId?: number;
    public warehouse?: boolean;

    constructor(locationPoint?) {
        super();
        if (locationPoint) {
            this.id = locationPoint.id;
            this.name = locationPoint.name;
            this.description = locationPoint.description;
            this.underReview = locationPoint.underReview;
            this.residential = locationPoint.residential;
            this.contactInfo = locationPoint.contactInfo ? new ContactInfo(locationPoint.contactInfo) : null;
            this.ciAddress = locationPoint.ciAddress;
            this.notes = locationPoint.notes;
            this.organisationId = locationPoint.organisationId;
            this.organisationName = locationPoint.organisationName;
            this.trafficArea = locationPoint.trafficArea;
            this.tp_required_location_skills = locationPoint.tp_required_location_skills;
            this.timeToService = locationPoint.timeToService ?? 0;
            this.podRequired = locationPoint.podRequired;
            this.isEmailNotificationEnabled = locationPoint.isEmailNotificationEnabled;
            this.emailForDeliveryNotification = locationPoint.emailForDeliveryNotification;
            this.notifyForDeliveryNotification = locationPoint.notifyForDeliveryNotification;
            this.deleted = locationPoint.deleted ? true : false;
            this.awaitingApproval = locationPoint.awaitingApproval ? true : false;
            this.type = locationPoint.type;
            this.completeAddress = [
                locationPoint.name,
                locationPoint.description,
                locationPoint.ciAddress?.line1,
                locationPoint.ciAddress?.countyState,
                locationPoint.ciAddress?.townCity,
                locationPoint.ciAddress?.postCodeZip
            ]
                .filter(Boolean)
                .join(', ');
            this.hasStandingTrailers = locationPoint.hasStandingTrailers;
            this.startTime = DiTime.newInstance(locationPoint.startTime);
            this.endTime = DiTime.newInstance(locationPoint.endTime);
            this.hasFixedPrice = locationPoint.hasFixedPrice;
            this.fixedPrice = locationPoint.fixedPrice;
            this.surveyId = locationPoint.surveyId;
            this.warehouse = locationPoint.warehouse;
        } else {
            this.contactInfo = new ContactInfo();
            this.notes = new Note();
            this.trafficArea = new TrafficArea();
            this.tp_required_location_skills = [];
            this.deleted = false;
            this.notifyForDeliveryNotification = 'THIRTY_MINS';
        }
    }

    get discriminator(): any {
        return this.name;
    }

    clone(): LocationPoint {
        return new LocationPoint(this);
    }
}
